export interface ColorSwatchOption {
  color: string;
  label: string;
}

export const COLOR_SWATCH_PRESETS: ColorSwatchOption[] = [
  { color: '#F5F0E6', label: 'Cream' },
  { color: '#4A4A4A', label: 'Charcoal' },
  { color: '#87CEEB', label: 'Sky Blue' },
  { color: '#A68B6B', label: 'Taupe' },
  { color: '#F5E6A3', label: 'Pale Yellow' },
  { color: '#9CAF88', label: 'Sage' },
  { color: '#C0C0C0', label: 'Silver' },
  { color: '#C9A9A6', label: 'Dusty Rose' },
  { color: '#C4A574', label: 'Tan' },
  { color: '#F4C4A0', label: 'Peach' },
  { color: '#FBFAF5', label: 'Off White' },
  { color: '#F8C8DC', label: 'Light Pink' },
  { color: '#9B59B6', label: 'Purple' },
  { color: '#B85C5C', label: 'Muted Red' },
  { color: '#C47244', label: 'Terracotta' },
  { color: '#FFFFFF', label: 'White' },
  { color: '#FFD700', label: 'Yellow' },
  { color: '#E74C3C', label: 'Red' },
  { color: '#3498DB', label: 'Blue' },
  { color: '#2ECC71', label: 'Green' },
];

export function normalizeHexColor(color: string): string {
  const normalized = color.trim();
  if (!normalized.startsWith('#')) return normalized;

  let hex = normalized.slice(1);
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  } else if (hex.length === 8) {
    hex = hex.slice(0, 6);
  }

  return `#${hex.toUpperCase()}`;
}
